import * as React from 'react';
import { MainMenuLeafItem, MainMenuSubItem } from './MainMenu';
import { Link } from 'components/link/Link';
import {style} from 'typestyle';

export class SubMenuItemComponent extends React.Component<SubMenuItemComponentProps> {

    public render() {
        return (
            <div style={{width: '100%'}}>
                <Link 
                        href={this.props.item.url} 
                        forceReload={this.props.item.url.lastIndexOf(".rsc") != this.props.item.url.length - 4}
                        className={styles.link}
                >
                    <div className={"material-icons " + (this.props.currentUrl == this.props.item.url ? styles.iconSelected : styles.icon)}>
                        trip_origin
                    </div>
                    <div className={this.props.currentUrl == this.props.item.url ? styles.titleSelected : styles.title}>
                        {this.props.item.title}
                    </div>
                </Link>
            </div>
        );
    }

}

export class SubMenuItemComponentProps {
    public item: MainMenuSubItem;
    public currentUrl: string;
}

const styles = {
    link: style({
        padding: '10px 20px 10px 60px', 
        cursor: 'pointer', 
        display: 'flex', 
        alignItems: 'center',
        textDecoration: 'none',
        $nest: {
            '&:visited': {

            },
            '&:hover': {
                opacity: 0.7
            }
        }
    }),
    icon: style({
        display: 'inline-block', 
        paddingRight: '20px', 
        color: 'rgba(255, 255, 255, 0.4)',
        fontSize: '10px'
    }),
    iconSelected: style({
        display: 'inline-block', 
        paddingRight: '20px', 
        color: '#03A9F4',
        fontSize: '10px'
    }),
    title: style({
        display: 'inline-block', 
        fontSize: '15px', 
        fontWeight: 400, 
        color: 'rgba(255, 255, 255, 0.75)'
    }),
    titleSelected: style({
        display: 'inline-block', 
        fontSize: '15px', 
        fontWeight: 400, 
        color: '#03A9F4'
    })
}